import { render, staticRenderFns } from "./AttendanceManagement_Clock.vue?vue&type=template&id=70776f8a&scoped=true"
import script from "./AttendanceManagement_Clock.vue?vue&type=script&lang=js"
export * from "./AttendanceManagement_Clock.vue?vue&type=script&lang=js"
import style0 from "./AttendanceManagement_Clock.vue?vue&type=style&index=0&id=70776f8a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70776f8a",
  null
  
)

export default component.exports